const initAccordion = (el) => {
    const trigger = el.querySelector("[data-accordion-trigger]");
    const content = el.querySelector("[data-accordion-content]");

    //  Individual Icons can show or hide
    //  examples are + and - icons
    const openIcon = el.querySelector("[data-accordion-icon-open]");
    const closeIcon = el.querySelector("[data-accordion-icon-close]");

    //  Used generally for chevrons, or any icon that rotates
    // requires data-accordion-icon-(closed/opened)-class
    const icon = el.querySelector("[data-accordion-icon]");

    trigger.addEventListener("click", () => {
        const state = el.getAttribute("data-accordion");
        console.log("clicked");
        if (state == "closed") {
            el.setAttribute("data-accordion", "open");
            openIcon && openIcon.classList.add("tw-hidden");
            closeIcon && closeIcon.classList.remove("tw-hidden");
            content && content.classList.remove("tw-hidden");

            icon && icon.classList.remove(icon.getAttribute("data-accordion-icon-closed-class"));
            icon && icon.classList.add(icon.getAttribute("data-accordion-icon-opened-class"));

        } else {
            el.setAttribute("data-accordion", "closed");
            openIcon && openIcon.classList.remove("tw-hidden");
            closeIcon && closeIcon.classList.add("tw-hidden");
            content && content.classList.add("tw-hidden");

            icon && icon.classList.add(icon.getAttribute("data-accordion-icon-closed-class"));
            icon && icon.classList.remove(icon.getAttribute("data-accordion-icon-opened-class"));
        }
    });
};

document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll("[data-accordion]");
    for (const accordion of accordions) {
        initAccordion(accordion);
    }
}, false);